import { apiGet, apiPost, apiPut, apiDelete } from '.';
import { BarePlan, Plan, PlanWithVenues, VenueDisposition } from '../../../shared/types/plan';
import { Property } from '../../../shared/types/property';
import { BareEvent } from '../../../shared/types/event';
import { BareContent } from '@go-shared/types/content';

export async function getSETPlanTemplates(propertyId: string): Promise<BarePlan[]> {
  let planTemplates = (await apiGet(`/property/${propertyId}/project`)) as any;
  return planTemplates;
}

export async function getSETPlanTemplate(projectId: string): Promise<PlanWithVenues> {
  return (await apiGet(`/set/project/${projectId}`)) as any;
}

export async function getPlan(planId: string): Promise<BarePlan> {
  return (await apiGet(`/project/${planId}`)) as any;
}

export async function createEvent(
  projectId: string,
  event: BareEvent,
  applyStaffToPlan?: boolean
): Promise<BareEvent> {
  let params = applyStaffToPlan ? { applyStaffToPlan: 'true' } : undefined;

  return (await apiPost(`/project/${projectId}/event`, event, params)) as any;
}

export async function updateEvent(
  projectId: string,
  event: BareEvent,
  key?: string,
  applyStaffToPlan?: boolean,
  transferToTargetDay?: string
): Promise<BareEvent> {
  let params: any = {};

  if (key) {
    params.key = key;
  }

  if (applyStaffToPlan) {
    params.applyStaffToPlan = 'true';
  }

  if (transferToTargetDay) {
    params.transferToTargetDay = transferToTargetDay;
  }

  return (await apiPut(`/project/${projectId}/event/${event._id}`, event, params)) as any;
}

export async function deleteEvent(projectId: string, eventId: string): Promise<BarePlan> {
  return (await apiDelete(`/project/${projectId}/event/${eventId}`)) as any;
}

export async function exportPlan(projectId: string): Promise<{ location: string }> {
  return apiPost(`/export/project/${projectId}`);
}
export async function updateVenueData(
  projectId: string,
  venueData: VenueDisposition
): Promise<BarePlan> {
  return (await apiPut(`/project/${projectId}/venue/${venueData.template}`, venueData)) as any;
}

export async function createContent(projectId: string, content: BareContent): Promise<BareEvent> {
  return (await apiPost(`/project/${projectId}/content`, content)) as any;
}

export async function updateContent(
  projectId: string,
  content: BareContent,
  key?: string,
  transferToTargetDay?: string
): Promise<BareEvent> {
  let params: any = key ? { key } : undefined;

  if (transferToTargetDay) {
    params.transferToTargetDay = transferToTargetDay;
  }

  return (await apiPut(`/project/${projectId}/content/${content._id}`, content, params)) as any;
}

export async function deleteContent(projectId: string, contentId: string): Promise<BarePlan> {
  return (await apiDelete(`/project/${projectId}/content/${contentId}`)) as any;
}

export function populate(barePlan: BarePlan, property: Property): Plan {
  return {
    ...barePlan,
    property,
  };
}

export function bare(plan: Plan): BarePlan {
  return {
    ...plan,
    property: plan.property._id,
  };
}
